import { useEffect, useState } from 'react';
import api from '@/api';
import { Truck } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

export default function AdminFreight() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get('/admin/freight').then(r => setItems(r.data)).catch(console.error).finally(() => setLoading(false));

  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.put(`/admin/freight/${id}/status`, { status });
    load();
  };

  return (
    <div className="space-y-5" data-testid="admin-freight-page">
      <div>
        <h1 className="font-heading text-2xl font-bold text-slate-900">FreightIQ Management</h1>
        <p className="text-slate-500 text-sm mt-0.5">All freight and logistics requests</p>
      </div>

      {loading ? (
        <div className="space-y-3">{[1,2].map(i => <div key={i} className="h-16 bg-white rounded-xl border animate-pulse" />)}</div>
      ) : (
        <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
          {items.length === 0 ? (
            <div className="p-12 text-center">
              <Truck className="w-10 h-10 text-slate-300 mx-auto mb-3" />
              <p className="text-slate-500">No freight requests yet</p>
            </div>
          ) : (
            <table className="w-full" data-testid="admin-freight-table">
              <thead>
                <tr className="border-b border-slate-100">
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Route</th>
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider hidden md:table-cell">Customer</th>
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider hidden sm:table-cell">Cargo</th>
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider hidden lg:table-cell">Container</th>
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-slate-500 uppercase tracking-wider">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50">
                {items.map(item => (
                  <tr key={item._id} className="hover:bg-slate-50 transition-colors">
                    <td className="px-5 py-4">
                      <p className="text-sm font-semibold text-slate-900">{item.origin}</p>
                      <p className="text-xs text-slate-400 mt-0.5">→ {item.destination}</p>
                    </td>
                    <td className="px-5 py-4 hidden md:table-cell text-sm text-slate-600">{item.customer_name}</td>
                    <td className="px-5 py-4 hidden sm:table-cell text-sm text-slate-600">{item.cargo_type || '—'}</td>
                    <td className="px-5 py-4 hidden lg:table-cell text-sm text-slate-600">{item.container_type || '—'}</td>
                    <td className="px-5 py-4">
                      <Select value={item.status} onValueChange={v => updateStatus(item._id, v)}>
                        <SelectTrigger className="w-32 h-7 text-xs" data-testid={`freight-status-${item._id}`}>
                          <SelectValue />
                        </SelectTrigger>
                        <SelectContent>
                          {['pending','active','in_transit','at_port','delivered'].map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
                        </SelectContent>
                      </Select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
